import type { CspPath } from '../../../CspPath';

const toRelativePath = (basePath: CspPath, absolutePath: CspPath, removeLeadingSlash = false): string => {
  const relativePath = absolutePath.replace(basePath, '');
  return removeLeadingSlash && relativePath.indexOf('/') === 0 ? relativePath.slice(1) : relativePath;
};

export const PathUtil = {
  toRelativePath,
};
